export const SERVICE_CREATE = 'serviceCreate'
export const SERVICE_EDIT = 'serviceEdit'
export const SERVICE_DELETE = 'serviceDelete'
export const SERVICE_GET = 'serviceGet'
export const SERVICES_GET = 'servicesGet'
export const CATEGORIES_GET = 'categoriesGet'
export const SERVICE_SEARCH = 'serviceSearch'